import { Button, Flex, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconEdit as EditIcon } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { useGovEvaluationUpdateUserData } from '@/module/GovEvaluation/model/GovEvaluationQuery';
import { GovAuthorEvaluation, GovEvalUserDataRequest } from '@/module/GovEvaluation/model/GovEvaluationTypes';

import { useAppNotification } from '@feature/utils';

import { GovEvaluationUserDataModalForm } from '../form/GovEvaluationUserDataModalForm';

interface GovEvaluationUserDataProps {
  data: GovAuthorEvaluation;
  canEdit: boolean;
}

export function GovEvaluationUserData({ data, canEdit }: GovEvaluationUserDataProps) {
  const { jobTitle, user, evaluation, canLeadDoctorate, domain } = data;
  const { t } = useTranslation();
  const [formOpened, { open: openForm, close: closeForm }] = useDisclosure(false);
  const { isPending, mutate } = useGovEvaluationUpdateUserData(evaluation.id);

  const notification = useAppNotification();
  const onSubmit = (values: GovEvalUserDataRequest) => {
    mutate(values, {
      onSuccess: () => {
        notification.success();
        closeForm();
      },
      onError: notification.error,
    });
  };

  return (
    <Flex
      w="100%"
      justify="space-between"
      align="center"
    >
      <Stack gap="4px">
        <Text fw="500">Date generale</Text>
        <Text>
          Nume: {user.lastName} {user.firstName}
        </Text>
        <Text size="sm">
          {t('govEvaluation.jobTitle')}: {jobTitle ? t(`jobTitleEnum.${jobTitle}`) : <em>{t('unspecified')}</em>}
        </Text>
        <Text size="sm">
          {t('govEvaluation.studyDomain')}: {domain ? `${domain.code} - ${domain.name}` : <em>{t('unspecified')}</em>}
        </Text>
        <Text size="sm">
          {t('govEvaluation.canLeadDoctorate')}: {canLeadDoctorate ? t('bool.YES') : t('bool.NO')}
        </Text>
      </Stack>
      <Button
        disabled={!canEdit}
        onClick={openForm}
        leftSection={<EditIcon size="14px" />}
        size="xs"
      >
        {t('button.edit')}
      </Button>
      {canEdit && formOpened && (
        <GovEvaluationUserDataModalForm
          onSubmit={onSubmit}
          isSubmitting={isPending}
          onClose={closeForm}
          evaluationId={evaluation.id}
        />
      )}
    </Flex>
  );
}
